import React from 'react'
import './index.less'
import http from 'src/helper/http'
import { inject, observer,  } from 'src/core/store'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import cdn from 'src/helper/cdn'//记得图片用这个过滤，否则会有人用图片来检测用户来源

@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: {},
    language: "en",
    isActive: 1,
    levelList: [
      { level: "1-9", pic: "/img/app/newhost/wealth/ic_wealth_lv_0_9.webp", effect: "" },
      { level: "10-19", pic: "/img/app/newhost/wealth/ic_wealth_lv_10_19.webp", effect: "/img/activity/level/jc_10.png" },
      { level: "20-29", pic: "/img/app/newhost/wealth/ic_wealth_lv_20_29.webp", effect: "/img/activity/level/jc_20.png" },
      { level: "30-39", pic: "/img/app/newhost/wealth/ic_wealth_lv_30_39.webp", effect: "/img/activity/level/jc_30.png" },
      { level: "40-49", pic: "/img/app/newhost/wealth/ic_wealth_lv_40_49.webp", effect: "/img/activity/level/jc_40.png" },
      { level: "50-59", pic: "/img/app/newhost/wealth/ic_wealth_lv_50_59.webp", effect: "/img/activity/level/jc_50.png" },
      { level: "60-69", pic: "/img/app/newhost/wealth/ic_wealth_lv_60_69.webp", effect: "/img/activity/level/jc_60.png" },
      { level: "70-79", pic: "/img/app/newhost/wealth/ic_wealth_lv_70_79.webp", effect: "/img/activity/level/jc_70.png" },
      { level: "80-89", pic: "/img/app/newhost/wealth/ic_wealth_lv_80_89.webp", effect: "/img/activity/level/jc_80.png" },
      { level: "90-99", pic: "/img/app/newhost/wealth/ic_wealth_lv_90_99.webp", effect: "/img/activity/level/jc_90.png" },
      { level: "100", pic: "/img/app/newhost/wealth/ic_wealth_lv_100.webp", effect: "/img/activity/level/jc_100.png" },

      // { level: "0", pic: "/img/activity/level/we/w0.png", effect: "" },
      // { level: "1-9", pic: "/img/activity/level/we/w1.png", effect: "" },
      // { level: "10-19", pic: "/img/activity/level/we/w2.png", effect: "/img/activity/level/jc_10.png" },
      // { level: "20-29", pic: "/img/activity/level/we/w3.png", effect: "/img/activity/level/jc_20.png" },
      // { level: "30-39", pic: "/img/activity/level/we/w4.png", effect: "/img/activity/level/jc_30.png" },
      // { level: "40-49", pic: "/img/activity/level/we/w5.png", effect: "/img/activity/level/jc_40.png" },
      // { level: "50-59", pic: "/img/activity/level/we/w6.png", effect: "/img/activity/level/jc_50.png" },
      // { level: "60-69", pic: "/img/activity/level/we/w7.png", effect: "/img/activity/level/jc_60.png" },
      // { level: "70-79", pic: "/img/activity/level/we/w8.png", effect: "/img/activity/level/jc_70.png" },
      // { level: "80-89", pic: "/img/activity/level/we/w9.png", effect: "/img/activity/level/jc_80.png" },
      // { level: "90-99", pic: "/img/activity/level/we/w10.png", effect: "/img/activity/level/jc_90.png" },
      // { level: "100", pic: "/img/activity/level/we/w11.png", effect: "/img/activity/level/jc_100.png" },
    ],
    charmList: [
      { level: "1-9", pic: "/img/app/newhost/charm/ic_charm_lv_0_9.webp", },
      { level: "10-19", pic: "/img/app/newhost/charm/ic_charm_lv_10_19.webp", },
      { level: "20-29", pic: "/img/app/newhost/charm/ic_charm_lv_20_29.webp", },
      { level: "30-39", pic: "/img/app/newhost/charm/ic_charm_lv_30_39.webp", },
      { level: "40-49", pic: "/img/app/newhost/charm/ic_charm_lv_40_49.webp", },
      { level: "50-59", pic: "/img/app/newhost/charm/ic_charm_lv_50_59.webp", },
      { level: "60-69", pic: "/img/app/newhost/charm/ic_charm_lv_60_69.webp", },
      { level: "70-79", pic: "/img/app/newhost/charm/ic_charm_lv_70_79.webp", },
      { level: "80-89", pic: "/img/app/newhost/charm/ic_charm_lv_80_89.webp", },
      { level: "90-99", pic: "/img/app/newhost/charm/ic_charm_lv_90_99.webp", },
      { level: "100", pic: "/img/app/newhost/charm/ic_charm_lv_100.webp", },
    ],
    hbsList: [
      // { level: "1-9", pic: "/img/activity/level/hbs01.png", },
      // { level: "10-19", pic: "/img/activity/level/hbs02.png", },
      // { level: "20-29", pic: "/img/activity/level/hbs03.png", },
      // { level: "30-39", pic: "/img/activity/level/hbs04.png", },
      // { level: "40-49", pic: "/img/activity/level/hbs05.png", },
      // { level: "50-59", pic: "/img/activity/level/hbs06.png", },
      // { level: "60-69", pic: "/img/activity/level/hbs07.png", },
      // { level: "70-79", pic: "/img/activity/level/hbs08.png", },
      // { level: "80-89", pic: "/img/activity/level/hbs09.png", },
      // { level: "90-99", pic: "/img/activity/level/hbs10.png", },
      // { level: "100", pic: "/img/activity/level/hbs11.png", },

      { level: "0", pic: "/img/activity/level/ru/r0.png", },
      { level: "1-9", pic: "/img/activity/level/ru/r1.png", },
      { level: "10-19", pic: "/img/activity/level/ru/r2.png", },
      { level: "20-29", pic: "/img/activity/level/ru/r3.png", },
      { level: "30-39", pic: "/img/activity/level/ru/r4.png", },
      { level: "40-49", pic: "/img/activity/level/ru/r5.png", },
      { level: "50-59", pic: "/img/activity/level/ru/r6.png", },
      { level: "60-69", pic: "/img/activity/level/ru/r7.png", },
      { level: "70-79", pic: "/img/activity/level/ru/r8.png", },
      { level: "80-89", pic: "/img/activity/level/ru/r9.png", },
      { level: "90-99", pic: "/img/activity/level/ru/r10.png", },
      { level: "100", pic: "/img/activity/level/ru/r11.png", },
    ],
    signList: [
      {
        list: [
          '/img/activity/level/act_level_1.png',
          '/img/activity/level/act_level_10.png',
          '/img/activity/level/act_level_20.png',
        ]
      },
      {
        list: [
          '/img/activity/level/act_level_30.png',
          '/img/activity/level/act_level_40.png',
          '/img/activity/level/act_level_50.png',
          '/img/activity/level/act_level_60.png',
          '/img/activity/level/act_level_70.png',
        ]
      },
      {
        list: [
          '/img/activity/level/act_level_80.png',
          '/img/activity/level/act_level_90.png',
          '/img/activity/level/act_level_100.png',
        ]
      },
    ],
    medalList: [
      {
        lv: "Lv.30",
        lvImg: "https://img.chatie.live/app/medal/images/active30.png"
      },
      {
        lv: "Lv.50",
        lvImg: "https://img.chatie.live/app/medal/images/active50.png"
      },
      {
        lv: "Lv.80",
        lvImg: "https://img.chatie.live/app/medal/images/active80.png"
      },
      {
        lv: "Lv.100",
        lvImg: "https://img.chatie.live/app/medal/images/active100.png"
      },
    ],
    headList: [
      {
        lv: "Lv.10",
        date: "7",
        lvImg: "/img/activity/level/head-lv10.png"
      },
      {
        lv: "Lv.20",
        date: "7",
        lvImg: "/img/activity/level/head-lv20.png"
      },
      {
        lv: "Lv.35",
        date: "7",
        lvImg: "/img/activity/level/head-lv35.png"
      },
      {
        lv: "Lv.100",
        date: "7",
        lvImg: "/img/activity/level/unknow.png"
      },
    ],
    CarList: [
      {
        lv: "Lv.15",
        date: "7",
        lvImg: "/img/activity/level/horse-lv15.png"
      },
      {
        lv: "Lv.25",
        date: "7",
        lvImg: "/img/activity/level/horse-lv25.png"
      },
      {
        lv: "Lv.40",
        date: "7",
        lvImg: "/img/activity/level/horse-lv40.png"
      },
      {
        lv: "Lv.100",
        date: "7",
        lvImg: "/img/activity/level/unknow.png"
      },
    ],
    ruleContentStatus: false
  }


  constructor(props) {
    super(props)
    this.levelStore = this.props.store.register('activity/level')
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log("language", language)
    
    await this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    setDocumentTitle(setlang(language, langM).documentTitle)
    let uid = await setUidToken(this.props.location.query)
    // let uid = await setUidToken()
    await this.RunOnStart(uid)
  }

  RunOnStart = async (uid) => {
    this.levelStore.getData()
  }

  componentDidMount() {
    setDocumentTitle(this.state.lang.documentTitle)
  }

  
  getProcess(userInfo) {
    let process = ""
    if (this.state.isActive == 1) {
      process = (userInfo.wealth )* 100000  / ((userInfo.wealth) + userInfo.wealthNext) 
      return parseInt(process)/1000 + "%" 
    } else if (this.state.isActive == 2) {
      process = (userInfo.charm )* 100000  / ((userInfo.charm) + userInfo.charmNext) 
      return parseInt(process)/1000 + "%" 
    }
  }

  getHbsProcess(userInfo) {
    let process = ""
    process = (userInfo.rubyVal - userInfo.rubyPre) / ((userInfo.rubyVal - userInfo.rubyPre) + userInfo.rubyValNext) * 100
    return parseInt(process) + "%"
  }

  getActProcess(activeInfo) {
    let process = ""
    process = (activeInfo.nowActive) / (activeInfo.nowActive + activeInfo.toNext) * 100
    return parseInt(process) + "%"
  }

  getExpProcess(number, type) {
    let process = ""
    process = number / 300 * 100
    if (type == 3) {
      process = number / 500 * 100
    }
    if (number == undefined) {
      process = 0
    }

    return parseInt(process) + "%"
  }

  render() {
    let { userInfo, uid, activeInfo, giftinfo, gameinfo, micinfo } = this.levelStore.data
    let { lang, language, isActive, levelList, upgradeList, charmList, hbsList } = this.state
    // language = 'ar'
    return (
      <div className={`level_page ${isActive == 3 ? "activityBg" : ""} ${isActive == 1 ? "defalut" : "activityBack"}`}>

        <div className="rule-part-main" style={{ display: `${this.state.ruleContentStatus ? "block" : "none"}` }}>
          <div className="rule-content-container">
            <div className="title">
              Rule adjustment
              <div className="close" onClick={() => { this.setState({ ruleContentStatus: false }) }}></div>
            </div>
            <div className="content">
              Dear App users, starting from May 12, 2023, the ownership rules for activity headwear and activity mount will be adjusted for all users who have increased their activity level.<br /><br />
              From this date, the ownership of the activity headwear and activity mount will be changed to seven days from the date of acquisition. During these seven days, you will be able to freely use and display your acquired activity headwear and vehicle. After seven days, the activity headweares and activity mounts will be repossessed and you will not be able to use them again.<br /><br />
              Please note that this change applies to all activity headweares and activity mounts, including those acquired before 12 May 2023. We want this change to balance the interests of all users as much as possible.<br /><br />
              If you have any questions, please feel free to contact our customer service team. Thank you for your support of App!<br /><br />
              May 12, 2023
            </div>
          </div>
          <div className="rule-shadow"></div>
        </div>

        <div className='tab_box'>
          <div className={`tab ${isActive == 1 && "activity"}`} onClick={() => { this.$logEvent("wealth_level_list"); this.setState({ isActive: 1 }) }}>{lang.nav1}</div>
          <div className={`tab ${isActive == 2 && "activity"}`} onClick={() => { this.$logEvent("charm_level_list"); this.setState({ isActive: 2 }) }}>{lang.nav2}</div>
          {false && <div className={`tab ${isActive == 3 && "activity"}`} onClick={() => { this.$logEvent("room_level_list"); this.setState({ isActive: 3 }) }}>{lang.nav3}</div>}
          {false && <div className={`tab ${isActive == 4 && "activity"}`} onClick={() => { this.$logEvent("charm_level_list"); this.setState({ isActive: 4 }) }}>{lang.nav4}</div>}

        </div>
        {isActive < 3 && <div className='user_box'>
          <div className='avater'>
            <img src={userInfo.avatarurl} alt="" />
          </div>
          <div className={`my_level ${isActive == 2 && "charmLevel"}`}><div>LV.{isActive == 1 ? userInfo.wealthLv : userInfo.charmLv}</div></div>
          <div className='need_exp'>{lang.Experience && lang.Experience.replace('AAA', isActive == 1 ? (userInfo.wealthNext  || 0) : (userInfo.charmNext || 0)).replace('BBB', isActive == 1 ? (userInfo.wealthLv+1 || 0) : (userInfo.charmLv+1  || 0))}</div>
          <div className={`process ${isActive == 2 && "charmProcess"}`}><div style={{ width: this.getProcess(userInfo) }}></div></div>
          <div className='level_info'>
            <div className='left'>Lv.{isActive == 1 ? userInfo.wealthLv : userInfo.charmLv}</div>
            <div className='right'>{this.getProcess(userInfo)}</div>
          </div>
        </div>}


        {isActive == 3 && <div className='user_box'>
          <div className='avater'>
            <img src={userInfo.avatarurl} alt="" />
          </div>
          <div className={`my_level charmLevel"}`}><div>LV.{activeInfo.nowLv}</div></div>
          <div className='need_exp'>{lang.Experience && lang.Experience.replace('AAA', activeInfo.toNext).replace('BBB', activeInfo.nextLv)}</div>
          <div className={`process  activityProcess`}><div style={{ width: this.getActProcess(activeInfo) }}></div></div>
          <div className='level_info'>
            <div className='left'>Lv.{activeInfo.nowLv}</div>
            <div className='right'>{this.getActProcess(activeInfo)}</div>
          </div>
        </div>}

        {isActive == 4 && <div className='user_box'>
          <div className='avater'>
            <img src={userInfo.avatarurl} alt="" />
          </div>
          <div className={`my_level ${isActive == 2 && "charmLevel"}`}><div>LV.{userInfo.rubyLv}</div></div>
          <div className='need_exp'>{lang.Experience && lang.Experience.replace('AAA', (userInfo.rubyValNext || 0)).replace('BBB', (userInfo.rubyNext || 0))}</div>
          <div className={`process ${isActive == 2 && "charmProcess"}`}><div style={{ width: this.getHbsProcess(userInfo) }}></div></div>
          <div className='level_info'>
            <div className='left'>Lv.{userInfo.rubyLv}</div>
            <div className='right'>{this.getHbsProcess(userInfo)}</div>
          </div>
        </div>}

        {isActive == 3 &&
          <div className={`activity_box ${language == 'ar' && 'arlang'}`}>
            <p className='actTitle'>{lang.Earn}</p>
            <div className='activity_list'>
              <div className='activity_list_box'>
                <p>{lang.mic}</p>
                <div className='activity_list_box_bottom'>
                  <div className='activity_list_box_bottom_left'>
                    <img src='/img/activity/level/exp_mic.png' />
                  </div>
                  <div className='activity_list_box_bottom_right'>
                    <div className='expbg'><div style={{ width: this.getExpProcess(micinfo.nowExp, 1) }}></div></div>
                    <p>1 {lang.Minute} = 1 EXP <span><font>{micinfo.nowExp ? micinfo.nowExp : 0}</font>/300</span></p>
                  </div>
                </div>
              </div>
              <div className='activity_list_box'>
                {/* <p>{lang.lucky}</p> */}
                <div className='activity_list_box_bottom'>
                  <div className='activity_list_box_bottom_left'>
                    <img src='/img/activity/level/exp_round.png' />
                  </div>
                  <div className='activity_list_box_bottom_right'>
                    <div className='expbg'><div style={{ width: this.getExpProcess(gameinfo.nowExp, 1) }}></div></div>
                    <p>1 {lang.round} = 1 EXP <span><font>{gameinfo.nowExp ? gameinfo.nowExp : 0}</font>/300</span></p>
                  </div>
                </div>
              </div>
              <div className='activity_list_box'>
                <p>{lang.sendGift}</p>
                <div className='activity_list_box_bottom'>
                  <div className='activity_list_box_bottom_left'>
                    <img src='/img/activity/level/exp_gifts.png' />
                  </div>
                  <div className='activity_list_box_bottom_right'>
                    <div className='expbg'><div style={{ width: this.getExpProcess(giftinfo.nowExp, 3) }}></div></div>
                    <p>50 {lang.Coins} = 10 EXP<span><font>{giftinfo.nowExp ? giftinfo.nowExp : 0}</font>/500</span></p>
                  </div>
                </div>
              </div>
            </div>

            <p className='actTitle'>{lang.refreshed}</p>

            <div className='sign'>
              <p>{lang.sign}</p>
              <div className='sign-img-box'>
                {
                  this.state.signList.map((item, i) => {
                    return (
                      <div key={i}>
                        {
                          item.list.map((item2, i2) => {
                            return (
                              <img src={item2} key={i2} />
                            )
                          })
                        }
                      </div>
                    )
                  })
                }
              </div>
            </div>

            <div className='sign medal'>
              <p>{lang.medal}</p>
              <div className='sign-img-box'>
                <div>
                  {
                    this.state.medalList.map((v, k) => {
                      return (
                        <div className='medal-img-box' key={k}>
                          <img src={v.lvImg} style={{ transform: `scale(${v.lvImg.indexOf("unknow.png") > 0 ? "0.7" : "1"})` }} />
                          <p>{v.lv}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>

            <div className='sign medal head'>
              <p>
                <span>{lang.headwear}</span>
                <span className='question' onClick={() => { this.setState({ ruleContentStatus: true }) }}></span>
              </p>
              <div className='sign-img-box'>
                <div>
                  {
                    this.state.headList.map((v, k) => {
                      return (
                        <div className='medal-img-box' key={k}>
                          <img src={v.lvImg} style={{ transform: `scale(${v.lvImg.indexOf("unknow.png") > 0 ? "0.7" : "1"})` }} />
                          <span>{v.date}{this.state.lang.days}</span>
                          <p>{v.lv}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>

            <div className='sign medal horse'>
              <p>
                <span>{lang.mount}</span>
                <span className='question' onClick={() => { this.setState({ ruleContentStatus: true }) }}></span>
              </p>
              <div className='sign-img-box'>
                <div>
                  {
                    this.state.CarList.map((v, k) => {
                      return (
                        <div className='medal-img-box' key={k}>
                          <img src={v.lvImg} style={{ transform: `scale(${v.lvImg.indexOf("unknow.png") > 0 ? "0.7" : "1"})` }} />
                          <span>{v.date}{this.state.lang.days}</span>
                          <p>{v.lv}</p>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>

          </div>
        }





        {isActive < 3 &&
          <div className='level_list'>
            {
              isActive == 1 &&
              <div>
                <div className='title'>
                  <div>{lang.range}</div>
                  <div>{lang.icons}</div>
                  <div>{lang.effects}</div>
                </div>
                {
                  levelList.map((r, i) => {
                    return (
                      <div className='every_level' key={i}>
                        <div>{r.level}</div>
                        <div> <img src={r.pic} alt="" /></div>
                        <div>{i == 0 ? "-" : <img src={r.effect} alt="" className='img_1' />}</div>
                      </div>
                    )

                  })
                }


              </div>
            }
            {
              isActive == 2 &&
              <div className='charm'>
                <div className='title'>
                  <div>{lang.range}</div>
                  <div>{lang.icons}</div>
                </div>
                {
                  charmList.map((r, i) => {
                    return (
                      <div className='every_level' key={i}>
                        <div>{r.level}</div>
                        <div> <img src={r.pic} alt="" /></div>
                      </div>
                    )

                  })
                }


              </div>
            }
          </div>

        }

        {isActive == 4 &&
          <div className='level_list'>
            {
              isActive == 4 &&
              <div className='charm'>
                <div className='title'>
                  <div>{lang.range}</div>
                  <div>{lang.icons}</div>
                </div>
                {
                  hbsList.map((r, i) => {
                    return (
                      <div className='every_level' key={i}>
                        <div>{r.level}</div>
                        <div className='new-icon'> <img src={r.pic} alt="" /></div>
                      </div>
                    )

                  })
                }


              </div>
            }
          </div>
        }


        {
          isActive == 1 &&
          <div className='upgrade_box'>
            <div className={`title ${language == 'ar' && 'arlang'}`}>{lang.upgrade}</div>
            <div className={`title2 ${language == 'ar' && 'arlang'}`}>{lang.Note}</div>
            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-gift@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Gifts}</div>
                  {/* <div className='info'>1 coin =1 Exp</div> */}
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>

            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-headwear@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Aristocracy}</div>
                  {/* <div className='info'>1 coin =1 Exp</div> */}
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>

            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-mount@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Mounts}</div>
                  {/* <div className='info'>1 coin =1 Exp</div> */}
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>
          </div >

        }
        {
          isActive == 2 &&
          <div className='upgrade_box'>
            <div className={`title ${language == 'ar' && 'arlang'}`}>{lang.upgrade}</div>
            <div className={`title2 ${language == 'ar' && 'arlang'}`}>{lang.Note2}</div>
            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-gift@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Receiving}</div>
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>

            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-headwear@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Aristocracy}</div>
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>

            <div className='every_upgrade'>
              <div className={`left ${language == 'ar' && 'arlang'}`}>
                <div className='pic'><img src="/img/activity/level/icon-mount@2x.png" alt="" /></div>
                <div className='word'>
                  <div className='tit'>{lang.Mounts}</div>
                </div>
              </div>
              {/* <div className='right'>{lang.Go}</div> */}
            </div>
          </div>

        }

      </div >
    )
  }
}




// WEBPACK FOOTER //
// src/pages/activity/level/index.js